import {
  formatLeaveDays,
  getEmployeeLeaveRemaining,
  leaveRemainingTone,
} from "../../utils/teamRequestsHelpers";
import "./TeamLeaveRemaining.css";

export function LeaveRemainingValue({ remaining, entitlement }) {
  const tone = leaveRemainingTone(remaining);
  return (
    <span className={`team-leave-remain team-leave-remain-${tone}`}>
      <strong>{formatLeaveDays(remaining)}</strong>
      <span className="team-leave-remain-of">
        من {formatLeaveDays(entitlement)}
      </span>
    </span>
  );
}

export function TeamLeaveRemainingPills({ employee }) {
  if (!employee) {
    return <span className="team-leave-pills-empty">—</span>;
  }

  const bal = getEmployeeLeaveRemaining(employee);
  return (
    <div className="team-leave-pills">
      <span className="team-leave-pill">
        <span className="team-leave-pill-label">اعتيادية</span>
        <LeaveRemainingValue
          remaining={bal.annualRemaining}
          entitlement={bal.annualEntitlement}
        />
      </span>
      <span className="team-leave-pill">
        <span className="team-leave-pill-label">عارضة</span>
        <LeaveRemainingValue
          remaining={bal.casualRemaining}
          entitlement={bal.casualEntitlement}
        />
      </span>
    </div>
  );
}
